import { render, staticRenderFns } from "./ConfirmUpload.vue?vue&type=template&id=54c91c5b&scoped=true&lang=pug&"
import script from "./ConfirmUpload.vue?vue&type=script&lang=js&"
export * from "./ConfirmUpload.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUpload.vue?vue&type=style&index=0&id=54c91c5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c91c5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c91c5b')) {
      api.createRecord('54c91c5b', component.options)
    } else {
      api.reload('54c91c5b', component.options)
    }
    module.hot.accept("./ConfirmUpload.vue?vue&type=template&id=54c91c5b&scoped=true&lang=pug&", function () {
      api.rerender('54c91c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/ConfirmUpload.vue"
export default component.exports